import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
    // Optionnel: envoyer l'erreur à un service de logs
    // fetch('/api/logs', { method: 'POST', body: JSON.stringify({ error, errorInfo }) })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-red-50 text-red-900">
          <div className="max-w-3xl mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4">Une erreur est survenue</h1>
            <p className="mb-4">Essayez d'actualiser la page. Si le problème persiste, partagez ce message d'erreur.</p>
            {this.state.error && (
              <pre className="bg-white p-4 rounded border border-red-200 overflow-auto text-sm">
{String(this.state.error?.message || this.state.error)}
              </pre>
            )}
            {this.state.errorInfo && (
              <details className="mt-4">
                <summary>Détails techniques</summary>
                <pre className="bg-white p-4 rounded border border-red-200 overflow-auto text-xs mt-2">
{this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
